/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Save_ChangesInputs */



/**
* | output |
* | --- |
* | "Save Changes" |
*
* @param {Deck_Save_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_save_changes = /** @type {((inputs?: Deck_Save_ChangesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Save_ChangesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar cambios")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Salvar alterações")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva modifiche")
	return /** @type {LocalizedString} */ ("Save Changes")
});